let ctx: AudioContext | null = null

function getContext(): AudioContext | null {
  try {
    const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    if (!Ctor) return null
    if (!ctx) ctx = new Ctor()
    if (ctx.state === 'suspended') void ctx.resume()
    return ctx
  } catch {
    return null
  }
}

/** A soft two-note chime. Synthesized, so there is nothing to load or license. */
export function playChime(): void {
  const audio = getContext()
  if (!audio) return
  try {
    const now = audio.currentTime
    const master = audio.createGain()
    master.gain.value = 0.18
    master.connect(audio.destination)
    ;[
      { freq: 587.33, at: 0 },
      { freq: 880, at: 0.18 },
    ].forEach(({ freq, at }) => {
      const osc = audio.createOscillator()
      const gain = audio.createGain()
      osc.type = 'sine'
      osc.frequency.value = freq
      gain.gain.setValueAtTime(0, now + at)
      gain.gain.linearRampToValueAtTime(1, now + at + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + 1.1)
      osc.connect(gain)
      gain.connect(master)
      osc.start(now + at)
      osc.stop(now + at + 1.2)
    })
  } catch {
    /* audio unavailable — completion is still shown on screen */
  }
}
